import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // How long data stays fresh before refetching
      staleTime: 5 * 60 * 1000, // 5 minutes
      // How long data stays in cache when unused
      gcTime: 10 * 60 * 1000, // 10 minutes      // Retry failed requests
      retry: 3,
      // Refetch on window focus
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Retry failed mutations
      retry: 1,
    },
  },
});
